export const getThemeColors = theme => {
    switch (theme) {
        case "coolBlues":
            return [
                "bg-[#92B2FF] hover:bg-[#749CFC]",
                "bg-[#749CFC] hover:bg-[#5274DC]",
                "bg-[#5274DC] hover:bg-[#1d4ed8]",
                "bg-[#1d4ed8] hover:bg-[#1e40af]",
                "bg-[#1e40af] hover:bg-[#081B5F]",
                "bg-[#081B5F] hover:bg-[#000b3f]"
            ]
        case "warmSunset":
            return [
                "bg-[#FF4500] hover:bg-[#e03e00]",
                "bg-[#ff7c43] hover:bg-[#ff6533]",
                "bg-[#ffa600] hover:bg-[#e69500]",
                "bg-[#ff6361] hover:bg-[#e55451]",
                "bg-[#bc5090] hover:bg-[#9f4273]",
                "bg-[#58508d] hover:bg-[#483c7b]"
            ]
        case "trafficLights":
            return [
                "bg-[#28A745] hover:bg-[#21883d]",
                "bg-[#85C441] hover:bg-[#75ab3a]",
                "bg-[#F0C419] hover:bg-[#d5aa17]",
                "bg-[#F2994A] hover:bg-[#db8540]",
                "bg-[#E64C3C] hover:bg-[#cb4132]",
                "bg-[#D7263D] hover:bg-[#bf1f33]"
            ]
        default:
            return [
                "bg-[#4f91e4] hover:bg-[#457ecd]",
                "bg-[#5a77d6] hover:bg-[#4f6bc0]",
                "bg-[#6a4fcf] hover:bg-[#5f44b9]",
                "bg-[#8535c4] hover:bg-[#742caa]",
                "bg-[#a62699] hover:bg-[#912283]",
                "bg-[#8b0e3e] hover:bg-[#7a0d35]"
            ]
    }
}

export const getThemeColorsText = theme => {
    switch (theme) {
        case "coolBlues":
            return [
                "text-[#92B2FF]",
                "text-[#749CFC]",
                "text-[#5274DC]",
                "text-[#1d4ed8]",
                "text-[#1e40af]",
                "text-[#081B5F]"
            ]
        case "warmSunset":
            return [
                "text-[#FF4500]",
                "text-[#ff7c43]",
                "text-[#ffa600]",
                "text-[#ff6361]",
                "text-[#bc5090]",
                "text-[#58508d]"
            ]
        case "trafficLights":
            return [
                "text-[#28A745]",
                "text-[#85C441]",
                "text-[#F0C419]",
                "text-[#F2994A]",
                "text-[#E64C3C]",
                "text-[#D7263D]"
            ]
        default:
            return [
                "text-[#4f91e4]",
                "text-[#5a77d6]",
                "text-[#6a4fcf]",
                "text-[#8535c4]",
                "text-[#a62699]",
                "text-[#8b0e3e]"
            ]
    }
}

export const getAcuityColor = acuity => {
	switch (acuity) {
		case 0:
			return "bg-green-100 text-green-700 ring-green-300/20"
		case 1:
			return "bg-green-200 text-green-800 ring-green-400/20"
		case 2:
			return "bg-green-300 text-green-900 ring-green-500/20"
		case 3:
			return "bg-yellow-200 text-yellow-800 ring-yellow-400/20"
		case 4:
			return "bg-orange-200 text-orange-800 ring-orange-400/20"
		case 5:
			return "bg-red-200 text-red-800 ring-red-500/20"
		default:
			return "bg-gray-100 text-gray-700 ring-gray-400/20"
	}
}